/**
 * @file   src\Pages\Buy Subscription.tsx
 * @brief  Buy Subscription page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Button, useState , useParams, Link, useEffect} from "../utils/thirdpartyComponents";
import { Accordion } from "react-bootstrap";
import CWFooter from "src/components/CWFooter";
import Gobackicon from "../assets/images/left-arrow-small.svg";
import referfriendicon from "../assets/images/refer-and-earn-img.svg";
import copyicon from "../assets/images/copy-promo-code.svg";
import shareicon from "../assets/images/share-icon.svg";
import "src/styles/inner-page-styles.scss";
import { pageURLs } from "src/utils/pageUrls";
import ShareModal from '../components/ShareModal';
import copy from 'clipboard-copy'
import { MessageToaster } from "src/utils/toastUtil";
import axios from '../config/axiosConfig';
import {ProfileApi} from "../utils/apiUrls";
import SmallLoader from '../components/SmallLoader';

const ReferFriend = () => {
    // Instantiate MessageToaster
    const toaster = new MessageToaster();

      // Route information variable
      const params = useParams();

    const [showModal, setShowModal] = useState(false);
    // State to set referral
    const [referralCode, setReferralCode] = useState('');
    const [totalReferredCount, setTotalReferredCount] = useState(0);
    const [totalFreeWashThroughReferral, setTotalFreeWashThroughReferral] = useState(0);
    const [loading, setLoading] = useState(false);
    const [referralCodeDescription, setReferralCodeDescription] = useState('');
    const [referralCodeSettings, SetReferralCodeSettings] = useState<any>(null);
    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    const handleCopyCode = () => {
        // copy refferal code
        copy(referralCode);
        // show success message
        toaster.toastSuccess("Code copied to clipboard!")

    };


    useEffect(() => {
        fetchReferralData();
    }, []);


    const fetchReferralData = async () => {
        // Instantiate MessageToaster
        const toaster = new MessageToaster();
        setLoading(true)
        try {
          const responseProfile = await axios.get(ProfileApi.USER_REFERRAL_FETCH);
          setLoading(false)
          if (responseProfile?.data?.error === 0) {
            setReferralCode(responseProfile?.data?.data?.UserReferralData?.ReferralCode);
            if(responseProfile?.data?.data?.UserReferralData?.TotalReferrals === '' || responseProfile?.data?.data?.UserReferralData?.TotalReferrals === undefined || responseProfile?.data?.data?.UserReferralData?.TotalReferrals === null)
            {
                setTotalReferredCount(0);
            }
            else
            {
                setTotalReferredCount(responseProfile?.data?.data?.UserReferralData?.TotalReferrals);
            }
            if(responseProfile?.data?.data?.UserReferralData?.FreeWashAvailable === '' || responseProfile?.data?.data?.UserReferralData?.FreeWashAvailable === undefined || responseProfile?.data?.data?.UserReferralData?.FreeWashAvailable === null)
            {
                setTotalFreeWashThroughReferral(0)
            }
            else
            {
                setTotalFreeWashThroughReferral(responseProfile?.data?.data?.UserReferralData?.FreeWashAvailable)
            }
            setReferralCodeDescription(responseProfile?.data?.data?.ReferralSettingsData?.Description);
            SetReferralCodeSettings(responseProfile?.data?.data?.ReferralSettingsData)
          } else {
            toaster.toastError(responseProfile?.data?.message);
            setReferralCode('');
            setReferralCodeDescription('')
          }
        } catch (error: any) {
            setLoading(false)
            setReferralCode('');
            setReferralCodeDescription('')
          throw new Error(error?.response?.data?.message || error?.message);
        }
      };

    return (

        <div className="common-content-wrap pb-170">
            <div className="inner-content-wrap">
                <div className="common-header two-block-header">
                    <div className="pe-4 ps-4 pt-0 pb-0 h-100">
                        <div className="common-header-inner">
                            <Link to={"/"+params.carwashname+"/"+pageURLs.settings} className="back-link"><img src={Gobackicon} alt="Car Wash App" /></Link> Refer a Friend
                        </div>
                    </div>
                </div>
                <div className="main-content-wrap pe-0 ps-0 pt-0">
                    <div className="refer-friend-wrap text-center">
                        <div className="points-wrap d-flex align-items-center justify-content-between">
                            <div className="title">Number of referral subscriptions</div>
                            <div className="point">{totalReferredCount}</div>
                        </div>
                        <div className="points-wrap d-flex align-items-center justify-content-between">
                            <div className="title">Number of free single washes available</div>
                            <div className="point">{totalFreeWashThroughReferral}</div>
                        </div>
                        <div className="refer-img"><img src={referfriendicon} alt="Car Wash App" /></div>
                        <h1>Refer and Earn</h1>
                        <p className="sub">Refer your friend and earn a referral bonus by sharing the referral code.</p>
                        <div className="referral-code-block d-flex justify-content-center align-items-center mb-4">
                            <p>Referral Code <span>{referralCode}</span></p>
                            <span onClick={handleCopyCode}><img src={copyicon} alt="Car Wash App" /></span>
                        </div>
                        <Button variant="primary" className="primary-btn btn-main" onClick={handleShow}>Share to Friends<img src={shareicon} alt="Car Wash App" /></Button>
                    </div>
                </div>
            </div>
            <div className="accordion-fixed-wrap">
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>How it Works</Accordion.Header>
                        <Accordion.Body>
                            Enjoying your membership? Invite your friends and family to the app by sharing your unique referral code. When they sign up and subscribe using your code, they will receive {referralCodeSettings?.FreeSingleWashesPerSignup} FREE single wash(es) and you will receive {referralCodeSettings?.ReferralSubscriptionsForSingleWash} FREE single wash(es) as well!  Share your code as much as possible!
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
            {loading && <SmallLoader />}
            <CWFooter activeLink="Settings"/>
            {referralCode ? <ShareModal show={showModal} handleClose={handleClose} type="RC" referralCode={referralCode} referralCodeDescription = {referralCodeDescription? referralCodeDescription :''} titleText="Refer and Earn" paraText="Share your referral code with friends and earn bonuses!"/> : ''}
        </div>
    )
}

export default ReferFriend;
